"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames2 = _interopRequireDefault(require("classnames"));

var _View = _interopRequireDefault(require("@instructure/ui-layout/lib/components/View"));

var _uiThemeable = _interopRequireDefault(require("@instructure/ui-themeable"));

var _ThemeablePropTypes = _interopRequireDefault(require("@instructure/ui-themeable/lib/utils/ThemeablePropTypes"));

var _LayoutPropTypes = _interopRequireDefault(require("@instructure/ui-layout/lib/utils/LayoutPropTypes"));

var _safeCloneElement = _interopRequireDefault(require("@instructure/ui-utils/lib/react/safeCloneElement"));

var _uid = _interopRequireDefault(require("@instructure/uid"));

var _uiTestable = _interopRequireDefault(require("@instructure/ui-testable"));

var _theme = _interopRequireDefault(require("./theme"));

var _dec, _dec2, _class, _class2, _temp;

var styles = {
  componentId: 'cnWSA',
  template: function template(theme) {
    return "\n\n.cnWSA_bcSS{border-radius:".concat(theme.borderRadius || 'inherit', ";box-sizing:border-box;color:").concat(theme.color || 'inherit', ";font-family:").concat(theme.fontFamily || 'inherit', ";font-size:").concat(theme.fontSize || 'inherit', ";font-weight:").concat(theme.fontWeight || 'inherit', ";pointer-events:none;text-align:center;white-space:nowrap}\n\n[dir=ltr] .cnWSA_bcSS,[dir=rtl] .cnWSA_bcSS{text-align:center}\n\n.cnWSA_bcSS:not(.cnWSA_bBTa){position:absolute;z-index:").concat(theme.notificationZIndex || 'inherit', "}\n\n.cnWSA_bcSS:not(.cnWSA_bBTa).cnWSA_dDWY.cnWSA_bXWC{top:calc(-1*").concat(theme.countOffset || 'inherit', ")}\n\n.cnWSA_bcSS:not(.cnWSA_bBTa).cnWSA_dDWY.cnWSA_KksD{top:").concat(theme.notificationOffset || 'inherit', "}\n\n.cnWSA_bcSS:not(.cnWSA_bBTa).cnWSA_bPSM.cnWSA_bXWC{bottom:calc(-1*").concat(theme.countOffset || 'inherit', ")}\n\n.cnWSA_bcSS:not(.cnWSA_bBTa).cnWSA_bPSM.cnWSA_KksD{bottom:").concat(theme.notificationOffset || 'inherit', "}\n\n.cnWSA_bcSS:not(.cnWSA_bBTa).cnWSA_fcMK.cnWSA_bXWC{inset-inline-end:auto;inset-inline-start:calc(-1*").concat(theme.countOffset || 'inherit', ")}\n\n[dir=ltr] .cnWSA_bcSS:not(.cnWSA_bBTa).cnWSA_fcMK.cnWSA_bXWC{left:calc(-1*").concat(theme.countOffset || 'inherit', ");right:auto}\n\n[dir=rtl] .cnWSA_bcSS:not(.cnWSA_bBTa).cnWSA_fcMK.cnWSA_bXWC{left:auto;right:calc(-1*").concat(theme.countOffset || 'inherit', ")}\n\n.cnWSA_bcSS:not(.cnWSA_bBTa).cnWSA_fcMK.cnWSA_KksD{inset-inline-end:auto;inset-inline-start:").concat(theme.notificationOffset || 'inherit', "}\n\n[dir=ltr] .cnWSA_bcSS:not(.cnWSA_bBTa).cnWSA_fcMK.cnWSA_KksD{left:").concat(theme.notificationOffset || 'inherit', ";right:auto}\n\n[dir=rtl] .cnWSA_bcSS:not(.cnWSA_bBTa).cnWSA_fcMK.cnWSA_KksD{left:auto;right:").concat(theme.notificationOffset || 'inherit', "}\n\n.cnWSA_bcSS:not(.cnWSA_bBTa).cnWSA_bXgF.cnWSA_bXWC{inset-inline-end:calc(-1*").concat(theme.countOffset || 'inherit', ");inset-inline-start:auto}\n\n[dir=ltr] .cnWSA_bcSS:not(.cnWSA_bBTa).cnWSA_bXgF.cnWSA_bXWC{left:auto;right:calc(-1*").concat(theme.countOffset || 'inherit', ")}\n\n[dir=rtl] .cnWSA_bcSS:not(.cnWSA_bBTa).cnWSA_bXgF.cnWSA_bXWC{left:calc(-1*").concat(theme.countOffset || 'inherit', ");right:auto}\n\n.cnWSA_bcSS:not(.cnWSA_bBTa).cnWSA_bXgF.cnWSA_KksD{inset-inline-end:").concat(theme.notificationOffset || 'inherit', ";inset-inline-start:auto}\n\n[dir=ltr] .cnWSA_bcSS:not(.cnWSA_bBTa).cnWSA_bXgF.cnWSA_KksD{left:auto;right:").concat(theme.notificationOffset || 'inherit', "}\n\n[dir=rtl] .cnWSA_bcSS:not(.cnWSA_bBTa).cnWSA_bXgF.cnWSA_KksD{left:").concat(theme.notificationOffset || 'inherit', ";right:auto}\n\n.cnWSA_bcSS:not(.cnWSA_bBTa).cnWSA_eCdq.cnWSA_bXgF.cnWSA_bXWC,.cnWSA_bcSS:not(.cnWSA_bBTa).cnWSA_eCdq.cnWSA_fcMK.cnWSA_bXWC{top:calc(50% - ").concat(theme.size || 'inherit', "/2)}\n\n.cnWSA_bcSS:not(.cnWSA_bBTa).cnWSA_eCdq.cnWSA_bXgF.cnWSA_KksD,.cnWSA_bcSS:not(.cnWSA_bBTa).cnWSA_eCdq.cnWSA_fcMK.cnWSA_KksD{top:calc(50% - ").concat(theme.sizeNotification || 'inherit', "/2)}\n\n.cnWSA_bcSS:not(.cnWSA_bBTa).cnWSA_eCdq.cnWSA_fcMK.cnWSA_bXWC{inset-inline-end:calc(100% - ").concat(theme.countOffset || 'inherit', ");inset-inline-start:auto}\n\n[dir=ltr] .cnWSA_bcSS:not(.cnWSA_bBTa).cnWSA_eCdq.cnWSA_fcMK.cnWSA_bXWC{left:auto;right:calc(100% - ").concat(theme.countOffset || 'inherit', ")}\n\n[dir=rtl] .cnWSA_bcSS:not(.cnWSA_bBTa).cnWSA_eCdq.cnWSA_fcMK.cnWSA_bXWC{left:calc(100% - ").concat(theme.countOffset || 'inherit', ");right:auto}\n\n.cnWSA_bcSS:not(.cnWSA_bBTa).cnWSA_eCdq.cnWSA_fcMK.cnWSA_KksD{inset-inline-end:auto;inset-inline-start:calc(-1*").concat(theme.sizeNotification || 'inherit', "/2)}\n\n[dir=ltr] .cnWSA_bcSS:not(.cnWSA_bBTa).cnWSA_eCdq.cnWSA_fcMK.cnWSA_KksD{left:calc(-1*").concat(theme.sizeNotification || 'inherit', "/2);right:auto}\n\n[dir=rtl] .cnWSA_bcSS:not(.cnWSA_bBTa).cnWSA_eCdq.cnWSA_fcMK.cnWSA_KksD{left:auto;right:calc(-1*").concat(theme.sizeNotification || 'inherit', "/2)}\n\n.cnWSA_bcSS:not(.cnWSA_bBTa).cnWSA_eCdq.cnWSA_bXgF.cnWSA_bXWC{inset-inline-end:auto;inset-inline-start:calc(100% - ").concat(theme.countOffset || 'inherit', ")}\n\n[dir=ltr] .cnWSA_bcSS:not(.cnWSA_bBTa).cnWSA_eCdq.cnWSA_bXgF.cnWSA_bXWC{left:calc(100% - ").concat(theme.countOffset || 'inherit', ");right:auto}\n\n[dir=rtl] .cnWSA_bcSS:not(.cnWSA_bBTa).cnWSA_eCdq.cnWSA_bXgF.cnWSA_bXWC{left:auto;right:calc(100% - ").concat(theme.countOffset || 'inherit', ")}\n\n.cnWSA_bcSS:not(.cnWSA_bBTa).cnWSA_eCdq.cnWSA_bXgF.cnWSA_KksD{inset-inline-end:calc(-1*").concat(theme.sizeNotification || 'inherit', "/2);inset-inline-start:auto}\n\n[dir=ltr] .cnWSA_bcSS:not(.cnWSA_bBTa).cnWSA_eCdq.cnWSA_bXgF.cnWSA_KksD{left:auto;right:calc(-1*").concat(theme.sizeNotification || 'inherit', "/2)}\n\n[dir=rtl] .cnWSA_bcSS:not(.cnWSA_bBTa).cnWSA_eCdq.cnWSA_bXgF.cnWSA_KksD{left:calc(-1*").concat(theme.sizeNotification || 'inherit', "/2);right:auto}\n\n.cnWSA_bcSS.cnWSA_bXWC{-webkit-padding-end:").concat(theme.padding || 'inherit', ";-webkit-padding-start:").concat(theme.padding || 'inherit', ";line-height:").concat(theme.size || 'inherit', ";min-width:").concat(theme.size || 'inherit', ";padding-inline-end:").concat(theme.padding || 'inherit', ";padding-inline-start:").concat(theme.padding || 'inherit', "}\n\n[dir=ltr] .cnWSA_bcSS.cnWSA_bXWC{padding-left:").concat(theme.padding || 'inherit', ";padding-right:").concat(theme.padding || 'inherit', "}\n\n[dir=rtl] .cnWSA_bcSS.cnWSA_bXWC{padding-left:").concat(theme.padding || 'inherit', ";padding-right:").concat(theme.padding || 'inherit', "}\n\n.cnWSA_bcSS.cnWSA_KksD{height:").concat(theme.sizeNotification || 'inherit', ";width:").concat(theme.sizeNotification || 'inherit', "}\n\n.cnWSA_zGXc{background-color:").concat(theme.colorDanger || 'inherit', "}\n\n.cnWSA_zGXc.cnWSA_fdSp:before{border-color:").concat(theme.colorDanger || 'inherit', "}\n\n.cnWSA_cOXX{background-color:").concat(theme.colorSuccess || 'inherit', "}\n\n.cnWSA_cOXX.cnWSA_fdSp:before{border-color:").concat(theme.colorSuccess || 'inherit', "}\n\n.cnWSA_bXiG{background-color:").concat(theme.colorPrimary || 'inherit', "}\n\n.cnWSA_bXiG.cnWSA_fdSp:before{border-color:").concat(theme.colorPrimary || 'inherit', "}\n\n@keyframes cnWSA_fdSp{to{opacity:0.9;transform:scale(1)}}\n\n.cnWSA_fdSp{position:relative}\n\n.cnWSA_fdSp:before{animation-direction:alternate;animation-duration:1s;animation-iteration-count:4;animation-name:cnWSA_fdSp;border:").concat(theme.pulseBorderThickness || 'inherit', " solid;border-radius:").concat(theme.borderRadius || 'inherit', ";box-sizing:border-box;content:\"\";height:calc(100% + 0.5rem);inset-inline-end:auto;inset-inline-start:-0.25rem;opacity:0;position:absolute;top:-0.25rem;transform:scale(0.75);width:calc(100% + 0.5rem)}\n\n[dir=ltr] .cnWSA_fdSp:before{left:-0.25rem;right:auto}\n\n[dir=rtl] .cnWSA_fdSp:before{left:auto;right:-0.25rem}\n\n.cnWSA_gasz{box-sizing:border-box;position:relative}\n\n.cnWSA_gasz svg{display:block}");
  },
  'badge': 'cnWSA_bcSS',
  'standalone': 'cnWSA_bBTa',
  'positioned--top': 'cnWSA_dDWY',
  'count': 'cnWSA_bXWC',
  'notification': 'cnWSA_KksD',
  'positioned--bottom': 'cnWSA_bPSM',
  'positioned--start': 'cnWSA_fcMK',
  'positioned--end': 'cnWSA_bXgF',
  'positioned--center': 'cnWSA_eCdq',
  'danger': 'cnWSA_zGXc',
  'pulse': 'cnWSA_fdSp',
  'success': 'cnWSA_cOXX',
  'primary': 'cnWSA_bXiG',
  'wrapper': 'cnWSA_gasz'
};

/**
---
category: components
---
**/
var Badge = (_dec = (0, _uiTestable.default)(), _dec2 = (0, _uiThemeable.default)(_theme.default, styles), _dec(_class = _dec2(_class = (_temp = _class2 =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2.default)(Badge, _Component);

  function Badge(props) {
    var _this;

    (0, _classCallCheck2.default)(this, Badge);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(Badge).call(this, props));
    _this._defaultId = (0, _uid.default)('Badge');
    return _this;
  }

  (0, _createClass2.default)(Badge, [{
    key: "countOverflow",
    value: function countOverflow() {
      var _this$props = this.props,
          count = _this$props.count,
          countUntil = _this$props.countUntil;

      if (countUntil > 1 && count >= countUntil) {
        return true;
      } else {
        return false;
      }
    }
  }, {
    key: "renderOutput",
    value: function renderOutput() {
      var _this$props2 = this.props,
          count = _this$props2.count,
          countUntil = _this$props2.countUntil,
          formatOverflowText = _this$props2.formatOverflowText,
          formatOutput = _this$props2.formatOutput,
          type = _this$props2.type; // If the badge count is >= than the countUntil limit, format the badge text
      // via the formatOverflowText function prop

      var formattedCount = type === 'count' && this.countOverflow() ? formatOverflowText(count, countUntil) : count;

      if (typeof formatOutput === 'function') {
        return formatOutput(formattedCount);
      } else {
        return type === 'count' ? formattedCount : null;
      }
    }
  }, {
    key: "renderBadge",
    value: function renderBadge() {
      var _classnames;

      var _this$props3 = this.props,
          count = _this$props3.count,
          margin = _this$props3.margin,
          pulse = _this$props3.pulse,
          placement = _this$props3.placement,
          standalone = _this$props3.standalone,
          type = _this$props3.type,
          variant = _this$props3.variant;
      return _react.default.createElement(_View.default, {
        margin: standalone ? margin : 'none',
        className: (0, _classnames2.default)((_classnames = {}, (0, _defineProperty2.default)(_classnames, styles.badge, true), (0, _defineProperty2.default)(_classnames, styles[type], type), (0, _defineProperty2.default)(_classnames, styles[variant], variant), (0, _defineProperty2.default)(_classnames, styles['positioned--top'], placement.indexOf('top') > -1), (0, _defineProperty2.default)(_classnames, styles['positioned--bottom'], placement.indexOf('bottom') > -1), (0, _defineProperty2.default)(_classnames, styles['positioned--start'], placement.indexOf('start') > -1), (0, _defineProperty2.default)(_classnames, styles['positioned--end'], placement.indexOf('end') > -1), (0, _defineProperty2.default)(_classnames, styles['positioned--center'], placement.indexOf('center') > -1), (0, _defineProperty2.default)(_classnames, styles.standalone, standalone), (0, _defineProperty2.default)(_classnames, styles.pulse, pulse), _classnames)),
        title: type === 'count' && this.countOverflow() ? count : null,
        id: !standalone ? this._defaultId : null,
        display: standalone ? 'inline-block' : 'block'
      }, this.renderOutput());
    }
  }, {
    key: "renderChildren",
    value: function renderChildren() {
      var _this2 = this;

      return _react.Children.map(this.props.children, function (child) {
        return (0, _safeCloneElement.default)(child, {
          'aria-describedby': _this2._defaultId
        });
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props4 = this.props,
          margin = _this$props4.margin,
          elementRef = _this$props4.elementRef,
          standalone = _this$props4.standalone,
          as = _this$props4.as;

      if (standalone) {
        return this.renderBadge();
      } else {
        return _react.default.createElement(_View.default, {
          as: as,
          margin: margin,
          elementRef: elementRef,
          className: styles.wrapper,
          display: "inline-block"
        }, this.renderChildren(), this.renderBadge());
      }
    }
  }]);
  Badge.displayName = "Badge";
  return Badge;
}(_react.Component), _class2.propTypes = {
  count: _propTypes.default.number,

  /**
   * The number at which the count gets truncated by
   * formatOverflowText. For example, a countUntil of 100
   * would stop the count at 99.
  */
  countUntil: _propTypes.default.number,
  children: _propTypes.default.element,

  /**
   * Render Badge as a counter (`count`) or as a smaller dot (`notification`) with
   * no count number displayed.
  */
  type: _propTypes.default.oneOf(['count', 'notification']),

  /**
   * Render Badge as an inline html element that is not positioned relative
   * to a child.
  */
  standalone: _propTypes.default.bool,

  /**
   * Make the Badge slowly pulse twice to get the user's attention.
  */
  pulse: _propTypes.default.bool,
  variant: _propTypes.default.oneOf(['primary', 'success', 'danger']),

  /**
  * Supported values are `top start`, `top end`, `end center`, `bottom end`,
  * `bottom start`, and `start center`
  */
  placement: _LayoutPropTypes.default.placement,

  /**
  * Valid values are `0`, `none`, `auto`, `xxx-small`, `xx-small`, `x-small`,
  * `small`, `medium`, `large`, `x-large`, `xx-large`. Apply these values via
  * familiar CSS-like shorthand. For example: `margin="small auto large"`.
  */
  margin: _ThemeablePropTypes.default.spacing,

  /**
  * provides a reference to the underlying html root element
  */
  elementRef: _propTypes.default.func,
  formatOverflowText: _propTypes.default.func,
  formatOutput: _propTypes.default.func,
  as: _propTypes.default.elementType // eslint-disable-line react/require-default-props

}, _class2.defaultProps = {
  count: void 0,
  children: null,
  countUntil: void 0,
  margin: void 0,
  formatOutput: void 0,
  standalone: false,
  type: 'count',
  variant: 'primary',
  pulse: false,
  placement: 'top end',
  elementRef: function elementRef(el) {},
  formatOverflowText: function formatOverflowText(count, countUntil) {
    return "".concat(countUntil - 1, " +");
  }
}, _temp)) || _class) || _class);
var _default = Badge;
exports.default = _default;